// Helpers for the three-tier nursing hierarchy:
// 1. Staff Nurse (general bedside nurse)
// 2. Ward Incharge (ward-level management and roster authoring)
// 3. Nursing Superintendent (hospital-wide leadership and incharge management)

export const NURSE_TIERS = {
  STAFF_NURSE: "nurse",
  WARD_INCHARGE: "ward_incharge",
  SUPERINTENDENT: "nursing_superintendent",
};

export function getEffectiveNurseRole(roleName) {
  if (!roleName) {
    const fromSession = sessionStorage.getItem("roleType");
    roleName = fromSession || "";
  }
  const norm = String(roleName).trim().toLowerCase();
  if (
    norm.includes("superintendent") ||
    norm.includes("super admin") ||
    norm.includes("facility admin") ||
    norm.includes("nurse manager") ||
    norm.includes("nursemanager") ||
    norm.includes("nursing manager") ||
    norm.includes("manager") ||
    norm.includes("matron") ||
    norm.includes("director of nursing")
  ) {
    return {
      tier: NURSE_TIERS.SUPERINTENDENT,
      label: "Nursing Superintendent",
      isSuperintendent: true,
      isIncharge: true,
      isStaffNurse: false,
    };
  }
  if (
    norm.includes("incharge") ||
    norm.includes("in charge") ||
    norm.includes("supervisor")
  ) {
    return {
      tier: NURSE_TIERS.WARD_INCHARGE,
      label: "Ward Incharge",
      isSuperintendent: false,
      isIncharge: true,
      isStaffNurse: false,
    };
  }
  return {
    tier: NURSE_TIERS.STAFF_NURSE,
    label: "Staff Nurse",
    isSuperintendent: false,
    isIncharge: false,
    isStaffNurse: true,
  };
}
